import _styled from "@emotion/styled-base";
export var StyledColumnCard = _styled("div", {
  target: "e11khqn00"
})({
  name: "1gor5g8",
  styles: "border-radius:0.5em;"
});
export var StyledColumnCardFlex = _styled("div", {
  target: "e11khqn01"
})({
  name: "1q4d1z6",
  styles: "align-items:center;box-sizing:border-box;display:grid;grid-template-columns:auto auto;grid-column-gap:6%;grid-row-gap:0.8em;justify-content:flex-start;padding:0 4%;.title-box,.subtitle-box,.text-box,.btn-box{padding:0;}.&--shadow{box-shadow:0 10px 25px 0 rgba(0,0,0,0.43);}"
});